import BlankRouterSection from '@/components/layout/BlankRouterSection'

export default {
  path: '/',
  name: 'auth',
  component: BlankRouterSection,
  redirect: '',
  children: [
    {
      path: 'signin',
      name: 'signin',
      component: () => import('@/views/Signin.vue')
    },  
    {
      path: 'translate/:seq',
      name: 'translate',
      component: () => import('@/views/popup/ResultDetailTranslate.vue')
    }  
  ]
}
